import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import notifications from '@/modules/notifications/module';
import ACL from './services/ACL';
import logger from './services/logger';
import TheMask from 'vue-the-mask';
import 'leaflet/dist/leaflet.css';
import '../public/player/style.css';
import '../src/modules/player/index.js';
import '@mdi/font/css/materialdesignicons.min.css';
import '@fontsource/montserrat';

import * as Sentry from '@sentry/vue';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;
Vue.use(notifications);
Vue.use(ACL);
Vue.use(logger);
Vue.use(TheMask);

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    Vue: Vue,
    dsn: 'https://3e9cf40c7802483ba4d95e5ec5224a50@sentry.simdev.ru/22',
    tracesSampleRate: 1.0,
    environment: process.env.VUE_APP_ENV || 'production',
    ignoreErrors: [
      'Network Error',
      'ResizeObserver loop limit exceeded',
      'Non-Error promise rejection detected',
    ],
    denyUrls: [
      /extensions\//i,
      /^chrome:\/\//i,
    ],
  });
}

const app = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');

export { app, store };
